import type { Property } from '@adc/sdk/types'
import type * as blueprint from '@adc/blueprint'
// @ts-ignore esModuleInterop
import React, { createContext, useContext, ReactNode } from 'react'
import { toggleSaveProperty as toggleSavePropertyFunction } from '../utils/property'

export type PropertyPageActionsType = {
  toggleSaveProperty: ReturnType<typeof toggleSavePropertyFunction>
}

export type SavedPropertiesDataType = ReturnType<
  typeof blueprint.user.hooks.useSavedProperties
>['data']

const PropertyContext = createContext<
  | {
      property: Property
      propertyActions?: PropertyPageActionsType
      savedPropertiesData?: SavedPropertiesDataType
    }
  | undefined
>(undefined)

export const usePropertyContext = () => {
  const context = useContext(PropertyContext)
  if (context === undefined) {
    throw new Error(
      'usePropertyContext must be used within a PropertyContextProvider'
    )
  }
  return context
}

interface PropertyProviderProps {
  children: ReactNode
  property: Property
  propertyActions?: PropertyPageActionsType
  savedPropertiesData?: SavedPropertiesDataType
}

export const PropertyProvider = ({
  children,
  property,
  propertyActions,
  savedPropertiesData,
}: PropertyProviderProps) => (
  <PropertyContext.Provider
    value={{ propertyActions, property, savedPropertiesData }}
  >
    {children}
  </PropertyContext.Provider>
)

export default PropertyProvider
